<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.customer.actions.unblockEmail.title')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', variant: 'warning', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script>
export default {
  props: {
    customer: {
      type: Object,
      required: true,
    },
    portal: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    info () {
      return this.$t('components.customer.actions.unblockEmail.info', { name: this.customer.displayName, id: this.customer.idCustomer, email: this.customer.email })
    },
  },
  methods: {
    open () {
      this.$refs.dialog.open()
    },
    async confirm () {
      try {
        const success = await this.$api.customer.unblockEmail(this.customer.objectID())

        if (success) {
          this.customer.emailBounced = false

          this.$notification.toast({
            title: this.$t('components.customer.actions.unblockEmail.success'),
            text: this.$t('components.customer.actions.unblockEmail.successInfo', { name: this.customer.displayName }),
          })

          this.$emit('update:customer', this.customer)
          this.$bus.emit.updated('Customer', this.customer)
          return true
        }
      } catch (e) {
        console.log(e)
        this.$notification.error({ errors: e?.errors })
      }
    },
  },
}
</script>
